var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCamera(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#151A30",
    d: "M23 6.75v12.214C23 20.088 22.076 21 20.937 21H3.063C1.925 21 1 20.088 1 18.964V6.75c0-1.124.924-2.036 2.063-2.036h3.78l.53-1.395A2.056 2.056 0 019.301 2h5.392c.86 0 1.629.526 1.93 1.319l.532 1.395h3.782c1.138 0 2.062.912 2.062 2.036zm-5.844 6.107c0-2.807-2.311-5.09-5.156-5.09-2.845 0-5.156 2.283-5.156 5.09 0 2.808 2.311 5.09 5.156 5.09 2.845 0 5.156-2.282 5.156-5.09zm-1.375 0c0 2.057-1.697 3.732-3.781 3.732s-3.781-1.675-3.781-3.732c0-2.057 1.697-3.732 3.781-3.732s3.781 1.675 3.781 3.732z"
  }))));
}

export default SvgCamera;